import { derived, type Readable, writable, type Writable } from "svelte/store";

type SearchTerm = string;

export class SearchfieldStore {
  value: Writable<SearchTerm> = writable("");
  target: Writable<SearchTerm> = writable("");
  isSuggestOpen: Writable<boolean> = writable(false);
  isFocus: Writable<boolean> = writable(false);
  isModified: Writable<boolean> = writable(false);

  get isEmpty(): Readable<boolean> {
    return derived(this.value, ($value: SearchTerm) => {
      if ($value.trim().length === 0) {
        this.isModified.set(false);
      }
      return $value.trim().length === 0;
    });
  }
}

export const searchfieldStore = new SearchfieldStore();
export const value = searchfieldStore.value;
export const target = searchfieldStore.target;
export const isModified = searchfieldStore.isModified;
export const isSuggestOpen = searchfieldStore.isSuggestOpen;
export const isFocus = searchfieldStore.isFocus;
